<template>
    <div class="columns is-multiline film_list" style="margin-top: 20px;">
        <template v-for="film in films" :key="film.id">
            <div v-if="!isShowActionsBlock && film.isPublished || isShowActionsBlock" class="column is-3 film_item">
                <div class="film_afisha_wrapper">
                    <template v-if="film.afisha">
                        <template v-if="!isShowActionsBlock">
                            <a :href="'/company_film/'+film.id">
                                <ImageRender
                                        class-name="zoomable_image"
                                        :src="getProjectAvatar(film.afisha)"
                                ></ImageRender>
                            </a>
                        </template>
                        <template v-else>
                            <ImageRender
                                    :src="getProjectAvatar(film.afisha)"
                            ></ImageRender>
                        </template>
                    </template>
                    <template v-else>
                        <div class="no_avatar_film">
                            <div class="svg_inner">
                                <svg width="127" height="115" viewBox="0 0 127 115" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.4461 0C7.71757 0.00331498 5.10173 1.08869 3.17236 3.01806C1.24299 4.94744 0.157612 7.56327 0.154297 10.2918V104.388C0.157612 107.117 1.24299 109.733 3.17236 111.662C5.10173 113.592 7.71757 114.677 10.4461 114.68H116.305C119.033 114.677 121.649 113.592 123.579 111.662C125.508 109.733 126.593 107.117 126.597 104.388V10.2918C126.593 7.56327 125.508 4.94744 123.579 3.01806C121.649 1.08869 119.033 0.00331498 116.305 0H10.4461ZM97.309 19.1765L85.481 29.4052H67.041L75.0829 22.4502C75.5669 22.0315 75.9539 21.5126 76.2173 20.9295C76.4806 20.3463 76.6139 19.7128 76.6079 19.0729C76.6019 18.4331 76.4568 17.8022 76.1825 17.2241C75.9083 16.6459 75.5116 16.1344 75.0199 15.7249L66.7352 8.82156H84.8838L97.309 19.1765ZM42.2548 15.7249L33.9703 8.82156H52.9573L65.3827 19.1765L53.5546 29.4052H34.2761L42.318 22.4502C42.8019 22.0315 43.189 21.5126 43.4523 20.9294C43.7156 20.3462 43.8489 19.7128 43.8429 19.0729C43.8369 18.4331 43.6917 17.8022 43.4175 17.224C43.1433 16.6459 42.7465 16.1344 42.2548 15.7249ZM8.97585 10.2918C8.9766 9.90211 9.13174 9.52857 9.40731 9.25301C9.68287 8.97744 10.0564 8.8223 10.4461 8.82156H20.1923L32.6176 19.1765L20.7896 29.4052H8.97585V10.2918ZM117.775 104.388C117.774 104.778 117.619 105.152 117.344 105.427C117.068 105.703 116.694 105.858 116.305 105.859H10.4461C10.0564 105.858 9.68287 105.703 9.40731 105.427C9.13174 105.152 8.9766 104.778 8.97585 104.388V38.2267H117.775V104.388ZM117.775 10.2918V29.4052H98.9675L107.009 22.4502C107.493 22.0315 107.88 21.5126 108.144 20.9294C108.407 20.3462 108.54 19.7128 108.534 19.0729C108.528 18.4331 108.383 17.8022 108.109 17.224C107.835 16.6459 107.438 16.1344 106.946 15.7249L98.6617 8.82156H116.305C116.694 8.8223 117.068 8.97744 117.344 9.25301C117.619 9.52857 117.774 9.90211 117.775 10.2918Z"
                                          fill="black" fill-opacity="0.1"/>
                                    <path d="M50.6864 91.1789C51.7513 91.842 52.9688 92.2201 54.222 92.2769C55.4752 92.3338 56.7219 92.0674 57.8424 91.5034L83.6093 78.6185C84.8308 78.0083 85.8582 77.0699 86.5764 75.9086C87.2946 74.7473 87.6752 73.4089 87.6755 72.0434C87.6758 70.678 87.2958 69.3394 86.5781 68.1778C85.8605 67.0162 84.8334 66.0774 83.6122 65.4666L57.8395 52.5817C56.7188 52.0217 55.4735 51.7574 54.222 51.814C52.9704 51.8706 51.754 52.2461 50.6884 52.9049C49.6228 53.5638 48.7432 54.484 48.1332 55.5784C47.5232 56.6727 47.2031 57.9048 47.2032 59.1577V84.9274C47.1992 86.1807 47.5174 87.4139 48.1274 88.5086C48.7374 89.6034 49.6186 90.5229 50.6864 91.1789ZM56.0247 61.5354L77.0362 72.0426L56.0247 82.5497V61.5354Z"
                                          fill="black" fill-opacity="0.1"/>
                                </svg>
                            </div>
                        </div>
                    </template>
								</div>

                <div class="film_item_elems" v-if="isShowActionsBlock">
                    <a :href="'/project/film/'+film.id"><i
                            class="far fa-edit" style="margin-left: 0; margin-right: 20px;"></i></a>
                    <Popconfirm
                            title="Вы действительно хотите удалить этот фильм?"
                            ok-text="Да"
                            cancel-text="Нет"
                            @confirm="delete_film(film.id)"
                            @cancel="() => {}"
                    >
                        <a style="" class="delete_link"><i
                                class="far fa-trash-alt"></i></a>
                    </Popconfirm>
                </div>

                <div class="film_type_block">

                    <div class="production" v-if="!film.isPublished">Черновик</div>
                    <template v-else>
                        <div class="realize" v-if="film.project_data?.status === 'Реализован'">
                            <svg width="20" height="18" viewBox="0 0 20 18" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_1735_2822)">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M18.8187 6.63502L14.5984 10.1814L15.779 15.3603C15.8251 15.5649 15.7375 15.7758 15.5553 15.8988C15.3739 16.0211 15.1319 16.034 14.9366 15.9296L9.99999 13.2915L5.06944 15.9296C4.87422 16.034 4.63211 16.0211 4.44997 15.8988C4.26859 15.7758 4.18097 15.5649 4.22709 15.3603L5.40763 10.1814L1.18128 6.63502C1.01911 6.49414 0.95916 6.27889 1.02833 6.08223C1.09674 5.88557 1.28197 5.74468 1.50177 5.71965L7.15855 5.1597L9.47891 0.315382C9.57037 0.123721 9.77481 0 10 0C10.2252 0 10.4296 0.123718 10.5211 0.315382L12.8415 5.15256L18.4982 5.71251C18.718 5.73754 18.9033 5.87843 18.9717 6.07509C19.0408 6.27104 18.9809 6.48701 18.8187 6.62788L18.8187 6.63502Z"
                                          fill="white"/>
                                </g>
                                <defs>
                                    <filter id="filter0_d_1735_2822" x="0" y="0" width="20" height="18"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                       result="hardAlpha"/>
                                        <feOffset dy="1"/>
                                        <feGaussianBlur stdDeviation="0.5"/>
                                        <feComposite in2="hardAlpha" operator="out"/>
                                        <feColorMatrix type="matrix"
                                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                                 result="effect1_dropShadow_1735_2822"/>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1735_2822"
                                                 result="shape"/>
                                    </filter>
                                </defs>
                            </svg>
                            <span>реализован</span>
                        </div>
                        <div class="production" v-if="film.project_data?.status === 'В производстве'">
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.50215 11.385C6.20447 11.385 6.77382 10.815 6.77382 10.1119C6.77382 9.40875 6.20447 8.83875 5.50215 8.83875C4.79982 8.83875 4.23047 9.40875 4.23047 10.1119C4.23047 10.815 4.79982 11.385 5.50215 11.385Z"
                                      fill="white"/>
                                <path d="M10.0568 11.385C10.7592 11.385 11.3285 10.815 11.3285 10.1119C11.3285 9.40875 10.7592 8.83875 10.0568 8.83875C9.35451 8.83875 8.78516 9.40875 8.78516 10.1119C8.78516 10.815 9.35451 11.385 10.0568 11.385Z"
                                      fill="white"/>
                                <path d="M14.6154 11.385C15.3178 11.385 15.8871 10.815 15.8871 10.1119C15.8871 9.40875 15.3178 8.83875 14.6154 8.83875C13.9131 8.83875 13.3438 9.40875 13.3438 10.1119C13.3438 10.815 13.9131 11.385 14.6154 11.385Z"
                                      fill="white"/>
                                <path d="M9.98844 0.204346C4.48555 0.204346 0 4.69509 0 10.2043C0 15.7136 4.48555 20.2043 9.98844 20.2043C15.4913 20.2043 20 15.7368 20 10.2043C20 4.69509 15.5145 0.204346 9.98844 0.204346ZM9.98844 18.8386C5.24856 18.8386 1.38728 14.9729 1.38728 10.2275C1.38728 5.48212 5.24856 1.61638 9.98844 1.61638C14.7283 1.61638 18.5896 5.48212 18.5896 10.2275C18.6127 14.9729 14.7514 18.8386 9.98844 18.8386Z"
                                      fill="white"/>
                            </svg>
                            <span>в производстве</span>
                        </div>
                    </template>
                </div>

                <div class="film_item_p__wrapper">
                    <template v-if="isShowActionsBlock">
                        <p class="film_item_p">{{ film.name }}</p>
                    </template>
                    <template v-else>
                        <p class="film_item_p"><a :href="'/company_film/'+film.id">{{ film.name }}</a></p>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import {Image, Popconfirm} from "ant-design-vue";
import {defineEmits} from "vue";
import axios from "axios";
import {defineProps, toRefs} from 'vue'
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

const emit = defineEmits(['update']);


const props = defineProps({
  films: {},
  isShowActionsBlock: {
    type: Boolean
  }
})
const {films} = toRefs(props);

async function delete_film(id) {
  await axios.get('/project/delete_ajax/' + id);
  emit('update')
}

function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}
</script>

<style scoped>
.film_list .film_item {
    max-width: 280px;
}

.film_item {
    display: flex;
    flex-direction: column;
    position: relative;
}

.film_item_p {
    flex-grow: 1;
    font-weight: 700;
    margin-bottom: 10px;
}

.film_item img {
    border-radius: 10px;
}

.film_item_p a {
    font-weight: 700;
    color: rgb(34, 34, 34);
}

.film_item_elems {
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: -35px;
    position: relative;
    z-index: 1111;
}

.film_item_p__wrapper {
    margin-top: 12px;
}

.film_item_p {
    font-size: 19px;
    font-weight: 600;
}

.film_type_block {
    margin-top: 25px;
}

.realize {
    background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    color: #fff;
    text-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    padding: 7px 12px;
    border-radius: 222px;
}

.realize svg {
    margin-right: 10px;
}

.realize span {
    margin-top: -2px;
}


.production {
    background: #1d232d;
    color: #fff;
    text-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    padding: 7px 12px;
    border-radius: 222px;
}

.production svg {
    margin-right: 10px;
}

.production span {
    margin-top: -2px;
}

.no_avatar_film {
    max-width: 280px;
    background: #E2E6EC;
    height: 382px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

}

.film_item:deep img, .film_item:deep .no_avatar_film {
    border-radius: 12px;
}

.no_avatar_film::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(5, 5, 5, 0.5) 100%);
    mask-image: linear-gradient(to bottom, transparent, black);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}
.film_afisha_wrapper {
		height: 100%;
}
</style>